import "./Sidebar.scss";

function Sidebar({ children }) {
  return <div className="sidebar">{children}</div>;
}

export default Sidebar;